import { ValidatorFn, AbstractControl } from "@angular/forms";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneNumberUtil = PhoneNumberUtil.getInstance();

export function PhoneNumberValidator(regionCode: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let validNumber = false;
    try {
      const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
      validNumber = phoneNumberUtil.isValidNumberForRegion(phoneNumber, regionCode);
    } catch (e) { }

    return validNumber ? null : { 'wrongNumber': { value: control.value } };
  }
}

export function PhoneNumberValidatorNotRequired(regionCode: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let validNumber = false;
    try {
      if (control.value) {
        const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(control.value, regionCode);
        validNumber = phoneNumberUtil.isValidNumberForRegion(phoneNumber, regionCode);
      } else {
        validNumber = true;
      }
    } catch (e) { }

    return validNumber ? null : { 'wrongNumber': { value: control.value } };
  }
}

export function transformPhoneNumber(phoneNumber: string, regionCode: string): string {
  try {
    return phoneNumberUtil.parse(phoneNumber, regionCode).getNationalNumber().toString();
  } catch (error) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/phone-number-validator.ts